import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../services/home.service';

import { users } from '../../../interfaces/users';
import { LanguageServiceService } from '../../../services/language-service.service';
import { LogoutService } from '../../Authentication/auth/logout.service';
import { BehaviorSubject, map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { ExcelExportService } from '../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../services/user';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-allusers',
  templateUrl: './allusers.component.html',
  styleUrl: './allusers.component.scss'
})

export class AllusersComponent implements OnInit {
  allData: users[] = [];
  displayedColumns: string[] = ['username', 'first_name', 'last_name', 'phone', 'type','has_access_to_phone_numbers', 'instagram_link',
    'tiktok_link', 'facebook_link'];
  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];

  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
 
  city_id?: number;

  id?: string;
  accounttype: string = '';
  isAdmin!: boolean;
  isAr: boolean = localStorage.getItem("language") == "ar";
  categories = [
    { id: 1, name: 'cat', nameAr: 'cat' },
    { id: 2, name: 'dog', nameAr: 'dog' },
  ];
  dataSource: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _languageService: LanguageServiceService,
    private _logoutService: LogoutService,
    private _userService: UserService,
    private fb: FormBuilder,
    private excelExportService: ExcelExportService,
  ) { this.dataSource = new MatTableDataSource(this.allData) }

  ngOnInit(): void {

    this._userService.getAccountType().subscribe({
      next: (data) => {

        const accountType = String(data['type'] ?? data['user_type'] ?? '').trim();
        const userType = String(data['user_type'] ?? '').trim().toLowerCase();

        this.isAdmin = accountType === '1' || userType === 'admin';

        // Accountants and sub-admins may edit users or view their passwords,
        // while deletion remains restricted to admins in the template.
        if (this.isAdmin || accountType === '2' || accountType === '6') {
          this.displayedColumns.push("delete");
        }

        this.getAllUsers();
      },
      error: (error) => console.error(error),
    });






  }
  go(url: string) {

    window.open(url);
  }
  deleteuser(id: string) {


    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._homeService.deleteUser(id).subscribe({
          next: (res) => {
            this.getAllUsers();
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  edituser(itemobj: any) {

    this.router.navigate(['/Resigter'], { queryParams: itemobj });

  }
  exportToExcel(): void {
    this.excelExportService.exportToExcel('userstable', 'BlueBox Users', ['delete']);
  }
  showpassword(password: any) {
    alert("user password is " + password);
  }
  getAllUsers() {
    this.contentReady = true;
    this.searched = false;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allData = data.reverse();
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
}
